import { ERR_GENERIC_LATER } from '../../constants/response-error-messages';
import { FULFILLMENT_TYPE } from '../../constants/status';
import { pushEventInfo, pushEventInfoWithFulfillment } from '../analytics';
// 1.1. Clicks to Edit Pickup Location Button
export var catchEditPickupLocationButtonClick = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: edit pickup location button',
        },
    });
};
// 1.2. Edit Pickup Location Button Displayed
export var trackEditPickupLocationButtonDisplayed = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: edit pickup location button displayed',
        },
    });
};
var getFulfillmentTypesPresent = function (fulfillmentType) {
    var sth = false;
    var boss = false;
    var bopis = false;
    var bodfs = false;
    var dfs = false;
    var appliance = false;
    var misc = false;
    switch (fulfillmentType) {
        case FULFILLMENT_TYPE.STH:
            sth = true;
            break;
        case FULFILLMENT_TYPE.BODFS:
            bodfs = true;
            break;
        case FULFILLMENT_TYPE.APPLIANCE:
            appliance = true;
            break;
        case FULFILLMENT_TYPE.DFS:
            dfs = true;
            break;
        case FULFILLMENT_TYPE.BOPIS:
            bopis = true;
            break;
        case FULFILLMENT_TYPE.BOSS:
            boss = true;
            break;
        default:
            misc = true;
            break;
    }
    return {
        sth: sth,
        bodfs: bodfs,
        appliance: appliance,
        dfs: dfs,
        bopis: bopis,
        boss: boss,
        misc: misc,
    };
};
// 1.3. Completion of Edit pickup location
export var trackConfirmPickupLocationChanges = function (fulfillmentType) {
    var fulfillmentTypes = getFulfillmentTypesPresent(fulfillmentType);
    var settings = "orders:sth:".concat(fulfillmentTypes.sth ? 'y' : 'n', "|boss:").concat(fulfillmentTypes.boss ? 'y' : 'n', "|bopis:").concat(fulfillmentTypes.bopis ? 'y' : 'n', "|bodfs:").concat(fulfillmentTypes.bodfs ? 'y' : 'n', "|appl:").concat(fulfillmentTypes.appliance ? 'y' : 'n', "|unknown:").concat(fulfillmentTypes.misc || fulfillmentTypes.dfs ? 'y' : 'n');
    pushEventInfoWithFulfillment({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: confirm changes button',
        },
        fulfillmentType: settings,
    });
};
//  2. Post Page Error
export var catchEditPickupLocationPostPageLoadError = function (errorCode) {
    pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'error',
                    displayType: 'inline',
                    pageSection: 'order details>edit pickup location',
                    message: ERR_GENERIC_LATER.message,
                    code: errorCode,
                },
            ],
        },
    });
};
// 1.4. Clicks to Go Back Button
export var catchGoBackButtonClick = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: cancel button',
        },
    });
};
